import AxiosService from "@/services/AxiosService";
import ICustomerItemServiceAdmin from "@/services/definition/ICustomerItemServiceAdmin";
import CustomerItemListFilterAdmin from "@/models/customer-item/CustomerItemListFilterAdmin";
import AsiListTableOptions from "@/components/common/AsiListTableOptions";
import IPaginatedResponse from "@/models/IPaginatedResponse";
import {ICustomerItemAdminListEntry} from "@/models/customer-item/CustomerItemAdminModels";
import Vue from "vue";

export default class AxiosCustomerItemServiceAdmin extends AxiosService implements ICustomerItemServiceAdmin {
	public static readonly BASE_URL = '/admin/customer-items';

	protected defineBaseUrl(): string {
		return AxiosCustomerItemServiceAdmin.BASE_URL;
	}

	public customerItems(filter: CustomerItemListFilterAdmin | null, options: AsiListTableOptions | null): Promise<IPaginatedResponse<ICustomerItemAdminListEntry>> {
		if (options === null) {
			options = new AsiListTableOptions();
			options.itemsPerPage = 0;
			options.sortDesc = [false];

		}
		return Vue.$axios.get<IPaginatedResponse<ICustomerItemAdminListEntry>>(this.url(), {
			params: {
				...filter,
				...options
			}
		}).then(res => res.data);
	}
}
